import { get } from "lodash";
import { Box, Select, Small } from "orcs-design-system";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  auth0UserMetadataKey,
  DIRECTORY_ROLE,
  POWER_ROLE,
  ADMIN_ROLE,
} from "src/services/auth";

const IMPERSONATION_ROLE_OPTIONS = [
  { value: DIRECTORY_ROLE, label: "Directory" },
  { value: POWER_ROLE, label: "Power" },
  { value: ADMIN_ROLE, label: "Admin" },
];

const SupportImpersonationRoleSelect = ({
  user,
  setSupportImpersonation,
  isReadonlyMode,
}) => {
  const metadataImpersonationRoles = get(
    user,
    [auth0UserMetadataKey, "impersonation", "roles"],
    []
  );
  const currentImpersonationRole = Array.isArray(metadataImpersonationRoles)
    ? metadataImpersonationRoles[0] || null
    : null;

  const [impersonationRole, setImpersonationRole] = useState(
    currentImpersonationRole
  );
  const [impersonationError, setImpersonationError] = useState("");
  const [isImpersonationBusy, setIsImpersonationBusy] = useState(false);

  useEffect(() => {
    setImpersonationRole(currentImpersonationRole);
  }, [currentImpersonationRole]);

  const onImpersonationRoleChange = async (option) => {
    if (isImpersonationBusy) {
      return;
    }

    const role = option?.value || null;
    const roles = role ? [role] : [];
    const previousRole = impersonationRole;

    setImpersonationError("");
    setImpersonationRole(role);
    setIsImpersonationBusy(true);

    try {
      await setSupportImpersonation({
        variables: { input: { roles } },
      });
      window.location.reload();
    } catch (err) {
      setImpersonationRole(previousRole);
      setImpersonationError(
        "Unable to update support impersonation right now. Please try again."
      );
      setIsImpersonationBusy(false);
    }
  };

  const selectedOption =
    IMPERSONATION_ROLE_OPTIONS.find((opt) => opt.value === impersonationRole) ||
    null;

  const isSelectDisabled = isImpersonationBusy || isReadonlyMode;

  return (
    <>
      <Box ml="s">
        <Select
          id="support-impersonation-role"
          hideLabel
          options={IMPERSONATION_ROLE_OPTIONS}
          value={selectedOption}
          onChange={onImpersonationRoleChange}
          isDisabled={isSelectDisabled}
          isLoading={isImpersonationBusy}
          isClearable={Boolean(impersonationRole)}
          placeholder="Select a role to impersonate..."
          height="30px"
          padding="0 8px"
        />
      </Box>
      {impersonationError && (
        <Small ml="s" weight="bold">
          {impersonationError}
        </Small>
      )}
    </>
  );
};

SupportImpersonationRoleSelect.propTypes = {
  user: PropTypes.object.isRequired,
  setSupportImpersonation: PropTypes.func.isRequired,
  isReadonlyMode: PropTypes.bool.isRequired,
};

export default SupportImpersonationRoleSelect;
